/**
 * @description 导出自定义配置
 **/
const config = {
  layout: 'vertical',
  donation: false,
  templateFolder: 'project',
}
export { config }
